require('environment');

import * as Sentry from '@sentry/browser';
import { Angular as AngularIntegration } from "@sentry/integrations";
import { versions } from './environments/versions';

require('history.js/history.js');
require('fullcalendar');
global.jQuery = require('jquery');
global._ = require('lodash');
global.moment = require('moment-timezone');
global.angular = require('angular');

if (application.use.sentryUrl) {
  Sentry.init({
    dsn: application.use.sentryUrl,
    environment: application.env,
    release: versions.revision,
    integrations: [new AngularIntegration()],
  });
}

global.async = require('async');
require('sortablejs');

require('angular-ui-router');
require('angular-animate');
require('angular-cookie');
require('angular-cookies');
require('angular-messages');
require('angular-sanitize');
require('angular-mocks');
require('angular-translate');
require('angular-translate-interpolation-messageformat');
require('angular-translate-loader-partial');
require('angular-translate-storage-cookie');
require('angular-translate-storage-local');
require('angular-resource');
require('babel-polyfill');
require('environment');
require('ng-redux');
require('sortablejs/ng-sortable');



// WEBPACK FOOTER //
// ../config/vendor.js